(function(){
  'use strict';
  const selector='[data-origin-agency-form][data-submission-enabled="true"]';
  let loading=null;
  function loadTurnstile(){
    if(window.turnstile&&typeof window.turnstile.render==='function')return Promise.resolve(window.turnstile);
    if(loading)return loading;
    loading=new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async=true;
      script.onload=()=>{
        const started=Date.now();
        const check=()=>{
          if(window.turnstile&&typeof window.turnstile.render==='function')resolve(window.turnstile);
          else if(Date.now()-started>8000)reject(new Error('Cloudflare verification did not initialize.'));
          else setTimeout(check,100);
        };
        check();
      };
      script.onerror=()=>reject(new Error('Cloudflare verification script was blocked or could not load.'));
      document.head.appendChild(script);
    }).catch(e=>{loading=null;throw e;});
    return loading;
  }
  function mount(form){
    if(form.dataset.agencyMounted==='true')return;
    form.dataset.agencyMounted='true';
    const submit=form.querySelector('[data-agency-submit]');
    const message=form.querySelector('[data-agency-message]');
    const row=submit&&submit.closest('.agency-contact__button-wrap');
    if(!submit||!row)return;
    const slot=form.querySelector('[data-agency-turnstile-slot]');
    const status=form.querySelector('[data-agency-turnstile-status]');
    if(!slot){console.error('[Origin Agency] Missing security verification area');return;}
    submit.disabled=true;
    let widget=null;
    let loaded=false;
    const sitekey=String(form.dataset.siteKey||'').trim();
    const show=(text,isError)=>{
      if(!message)return;
      message.hidden=false;
      message.textContent=text;
      message.style.cssText='display:block;margin-bottom:18px;text-align:center;color:'+(isError?'#a2261d':'inherit');
    };
    if(!sitekey){status.textContent='Security Site Key missing. Please contact Origin Pro.';return;}
    loadTurnstile().then(api=>{
      if(!form.isConnected)return;
      // Keep the status outside the widget container: Managed mode can render invisibly.
      const widgetHost=document.createElement('div');
      widgetHost.className='origin-agency-turnstile-widget';
      slot.appendChild(widgetHost);
      if(status)status.textContent='Cloudflare Turnstile: checking your browser…';
      widget=api.render(widgetHost,{
        sitekey,
        theme:'auto',
        'error-callback':(code)=>{
          submit.disabled=true;
          if(status)status.textContent='Cloudflare Turnstile verification unavailable';
          show('Security verification failed'+(code?' ('+String(code)+')':'')+'. Please refresh.',true);
        },
        'expired-callback':()=>{
          submit.disabled=true;
          if(status)status.textContent='Cloudflare Turnstile verification expired';
          show('Security verification expired. Please complete it again.',true);
        },
        callback:()=>{
          if(status)status.textContent='Cloudflare Turnstile verified';
          submit.disabled=false;
        }
      });
      loaded=true;
      // Submission remains disabled until the verified callback is received.
    }).catch(e=>{status.textContent='Security verification unavailable. Please refresh and try again.';show(e.message,true);});
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(!loaded||widget===null){show('Security verification is loading. Please try again.',true);return;}
      if(!form.reportValidity())return;
      const token=window.turnstile?.getResponse(widget)||'';
      if(!token){show('Please complete the security verification.',true);return;}
      const fd=new FormData(form);
      const payload=Object.fromEntries(fd.entries());
      payload.turnstileToken=token;
      submit.disabled=true;
      const label=submit.textContent;
      submit.textContent='Submitting…';
      try{
        const response=await fetch('/apps/origin-account-admin?action=agency-submit',{
          method:'POST',
          credentials:'same-origin',
          headers:{'Accept':'application/json','Content-Type':'application/json'},
          body:JSON.stringify(payload)
        });
        const data=await response.json().catch(()=>({}));
        if(!response.ok||data.ok===false||data.error)throw new Error(data.message||data.error||'Application could not be submitted.');
        const redirect=new URL(data.redirect||'/pages/pro-dashboard',location.origin);
        if(redirect.origin===location.origin&&redirect.pathname==='/pages/pro-dashboard'){
          location.assign(redirect.href);
          return;
        }
        throw new Error('Unexpected submission redirect.');
      }catch(e){
        show(e.message||'Application submission failed. Please retry.',true);
        window.turnstile?.reset(widget);
        submit.disabled=false;
        submit.textContent=label;
      }
    });
  }
  function scan(){document.querySelectorAll(selector).forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
})();